// Centralised Spanish language file for UI text in Weather App
// Please keep keys in sync with en.ts for consistency

const es = {
  app: {
    title: 'WeatherUp!',
    welcome: '¡Bienvenido a WeatherUp! 🌤️',
    subtitle: 'Tiempo Mundial',
    instructions: 'Introduce el nombre de una ciudad para comprobar el tiempo y mantenerte informado sobre las condiciones actuales. Comienza escribiendo en la caja de búsqueda de arriba. ¡Feliz exploración!'
  },
  weather: {
    loading: 'Cargando datos meteorológicos...',
    cardTitle: 'Tiempo para',
    currentTemp: 'Temperatura Actual',
    min: 'Min:',
    max: 'Max:',
    localTime: 'Hora Local',
    details: 'Detalles del Tiempo',
    humidity: 'Humedad',
    pressure: 'Presión',
    windSpeed: 'Velocidad del viento',
    visibility: 'Visibilidad',
    feelsLike: 'Sensación térmica',
  },
  search: {
    placeholder: 'Buscar una ciudad...',
    ariaLabel: 'Buscar una ciudad',
    button: 'Buscar',
    noResults: 'No se han encontrado ubicaciones.'
  }
};

export default es;
